import { SessionView } from "admin/src/server/mappers/session/session";

export const profileHasTags = (
  tags: string[],
  session: SessionView,
): boolean => {
  if (session.societyAdmin) {
    return true;
  }
  if (tags.length === 0) {
    return true;
  }
  if (
    session.profile?.tags
      ?.map((userTags) => userTags.name)
      .some((userTags) => tags.includes(userTags))
  ) {
    return true;
  }
  return false;
};
